import { useMutation, useQueryClient } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
interface CancelSubscriptionProps {
  reason: string
  id: string
}
const useCancelSubscription = (id: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ reason, id }: CancelSubscriptionProps) => {
      const url = `${ENDPOINTS.SUBSCRIPTION}/${id}/cancel`
      const body = {
        reason,
        termsServices: true,
      }
      await api.put(url, body)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [`${ENDPOINTS.SUBSCRIPTION}/${id}/cancel`, { id }],
      })
    },
  })
}
export default useCancelSubscription
